<template>
  <div class="dataDisplay">
    <!-- <data-header></data-header> -->
    <router-view></router-view>  
    <tab></tab>   
  </div>

</template>
<script>
import Tab from 'components/tab'
import DataHeader from 'components/dataHeader'
export default {
  components: {
    Tab,
    DataHeader
  }
}
</script>
<style scoped>
  .dataDisplay{
    width: 100%;
    height: 100%;
    background-color: #f1f2f3
  }
  .tab{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/dataDisplay.vue